// removed by extract-text-webpack-plugin
module.exports = {"podGrid":"CwPodGrid-podGrid","defaultLayout":"CwPodGrid-defaultLayout"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpodgrid/CwPodGrid.scss
// module id = 381
// module chunks = 0